import "slick-carousel";
$(".hero-carousel").slick({
  dots: true,
  arrows: true,
  infinite: false,
  speed: 300,
  slidesToShow: 1,
  slidesToScroll: 1,
  accessibility: true,
  responsive: [
    {
      breakpoint: 900,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
        infinite: true,
        arrows: false,
        dots: true,
      },
    },
    {
      breakpoint: 575, //575
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: false,
        dots: true,
      },
    },

    // You can unslick at a given breakpoint now by adding:
    // settings: "unslick"
    // instead of a settings object
  ],
});
$(".benefits-carousel").slick({
  dots: true,
  arrows: true,
  infinite: false,
  speed: 300,
  slidesToShow: 3,
  slidesToScroll: 3,
  accessibility: true,
  responsive: [
    {
      breakpoint: 900,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 3,
        // infinite: true,
        arrows: true,
        dots: true,
      },
    },
    {
      breakpoint: 575, //575
      settings: {
        slidesToShow: 2.6,
        slidesToScroll: 2.6,
        arrows: true,
        dots: true,
      },
    },
  ],
});
$(".immobile-carousel").slick({
  dots: true,
  arrows: true,
  infinite: false,
  speed: 300,
  slidesToShow: 1,
  slidesToScroll: 1,
  accessibility: true,
  responsive: [
    {
      breakpoint: 900,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
        // infinite: true,
        arrows: true,
        dots: true,
      },
    },
    {
      breakpoint: 575, //575
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: true,
        dots: true,
      },
    },
  ],
});
$(".news-details-carousel").slick({
  dots: true,
  arrows: true,
  infinite: false,
  speed: 300,
  slidesToShow: 3,
  slidesToScroll: 2,
  accessibility: true,
  responsive: [
    {
      breakpoint: 900,
      settings: {
        slidesToShow: 2.5,
        slidesToScroll: 2,
        arrows: true,
        dots: true,
      },
    },
    {
      breakpoint: 575,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 2,
        arrows: true,
        dots: true,
      },
    },
    {
      breakpoint: 400,
      settings: {
        slidesToShow: 1.2,
        slidesToScroll: 1,
        arrows: true,
        dots: true,
      },
    },
  ],
});

$(".tab-btn").on("click", function () {
  $(".benefits-carousel").slick("refresh");
});

$(".hero-carousel-slide-1").slick({
  dots: false,
  arrows: false,
  infinite: false,
  slidesToShow: 1,
  slidesToScroll: 1,
});
